import { render, staticRenderFns } from "./WarehouseDetails.vue?vue&type=template&id=0f959ff2&"
import script from "./WarehouseDetails.vue?vue&type=script&lang=js&"
export * from "./WarehouseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports